export const API_ENDPOINTS = {
  load: '/product-reviews/api/1/product-review/${productSku}',
  add: '/product-reviews/api/1/product-review/${productSku}',
  loadProductList: '/product-reviews/api/1/product-rating',
};
